import _ from 'lodash';
import moment from 'moment';
import Vue from 'vue';
import Cookies from 'cookies-js';
import {AxiosResponse} from 'axios';
import {mapActions} from 'vuex';
import StorageService from '../../lib/services/storageService';
import LifeSpaService from '../../lib/services/lifeSpaService';
import EventHub from '../../lib/eventHub';
import {ClubModuleConstant, EventConstant, CookieConstant, MemberStateConstant, ServiceConstant, ProfileModuleConstant, StorageConstant, UrlModuleConstant, BookingConstant} from '../../lib/constants';
import BookingDetail from './booking-detail.html';
import LifeSpa from 'types/ls/lifespa';
import LtFramework from 'types/lt/ltFramework';

const storageService: LtFramework.IStorageService = new StorageService();

interface IComponentData {
	lifeSpaServiceLoading: boolean;
	slot: LifeSpa.ISlot;
	club: LtFramework.IClub;
	date: any;
	endTime: any;
	endTimeSession: any;
	profile: LtFramework.IProfile;
	spabizToken: string;
	loginPath: string;
	bookingConfirmationPage: string;
	startTime: string;
}

const lifeSpaService: LifeSpa.ILifeSpaService = new LifeSpaService();

export default Vue.component('lifeSpaBookingDetail', {
	template: BookingDetail,
	data(): IComponentData {
		return {
			lifeSpaServiceLoading: false,
			slot: {} as LifeSpa.ISlot,
			club: {} as LtFramework.IClub,
			date: '',
			endTime: '',
			endTimeSession: '',
			profile: {} as LtFramework.IProfile,
			spabizToken: '',
			loginPath: '',
			bookingConfirmationPage: '',
			startTime: '',
		};
	},
	computed: {
		canBook: function(): any {
			return this.profile.memberState === MemberStateConstant.authenticated || this.profile.memberState === MemberStateConstant.remembered && this.spabizToken;
		},
	},
	methods: {
		...mapActions(ClubModuleConstant.name, {
			synchronizeClubStore: ClubModuleConstant.action.synchronize,
		}),
		...mapActions(ProfileModuleConstant.name, {
			synchronizeProfileStore: ProfileModuleConstant.action.synchronize,
		}),
		...mapActions(UrlModuleConstant.name, {
			synchronizeUrlStore: UrlModuleConstant.action.synchronize,
		}),
		book(slot: LifeSpa.ISlot, e: Event) {
			e.preventDefault();
			const spabizToken: string = Cookies.get(CookieConstant.spabizToken);

			if (spabizToken) {
				const bookAppointmentData: LifeSpa.ISpaBizAppointmentInfo = {
					locationId: this.club.id.toString(),
					id: slot.serviceId,
					staffId: slot.staffId,
					timeslot: moment(slot.fulldatetime, 'DD-MMM-YYYY H:mm A').format('DD-MMM-YYYY H:mm'),
					customerId: spabizToken,
					endTime: slot.duration.toString(),
					channel: BookingConstant.channelId,
				};
				lifeSpaService.bookAppointment(bookAppointmentData).then((response: AxiosResponse<LifeSpa.ISpaBizAppointmentResponse>) => {
					window.location.assign(this.bookingConfirmationPage);
				}).catch((error: any) => {
					if (error.response && (error.response.status === 409)) {
						const msg: string = ServiceConstant.bookingError.replace('{{availableBookings}}', this.club.pages.lifespaBooking);
						window.LtFramework.actions.createDangerNotification(msg, false, true);
					}
				});
			} else {
				// get customer id from spabiz
				const loginData: LifeSpa.ISpaBizLoginData = {
					locationId: this.club.id,
					accessToken: this.profile.sso,
				};
				lifeSpaService.getSpaBizUser(loginData).then((response: AxiosResponse<LifeSpa.ISpaBizUser>) => {
					Cookies.set(CookieConstant.spabizToken, response.data.id, {expires: CookieConstant.spabizTokenExpires});
					const bookAppointmentData: LifeSpa.ISpaBizAppointmentInfo = {
						locationId: this.club.id.toString(),
						id: slot.serviceId,
						staffId: slot.staffId,
						timeslot: moment(slot.fulldatetime, 'DD-MMM-YYYY H:mm A').format('DD-MMM-YYYY H:mm'),
						customerId: response.data.id.toString(),
						endTime: slot.duration.toString(),
						channel: BookingConstant.channelId,
					};
					lifeSpaService.bookAppointment(bookAppointmentData).then((appointmentResponse: AxiosResponse<LifeSpa.ISpaBizAppointmentResponse>) => {
						window.location.assign(this.bookingConfirmationPage);
					});
				}).catch((error: any) => {
					if (error.response && (error.response.status === 409)) {
						const msg: string = ServiceConstant.bookingError.replace('{{availableBookings}}', this.club.pages.lifespaBooking);
						window.LtFramework.actions.createDangerNotification(msg, false, true);
					}
				});
			}
		},
	},
	created(): void {
		EventHub.$on(EventConstant.LifeSpaServiceLoading, (loading: boolean) => {
			this.lifeSpaServiceLoading = loading;
		});
		// @ts-ignore
		Promise.all([this.synchronizeClubStore(), this.synchronizeUrlStore(), this.synchronizeProfileStore()]).then(() => {
			this.profile = window.LtFramework.getStore('ProfileStore').getInitialData();
			this.loginPath = window.LtFramework.getStore('UrlStore').getInitialData().globalPageDrivers.loginResource;
			this.club = window.LtFramework.getStore('ClubStore').getInitialData();
			this.spabizToken = Cookies.get(CookieConstant.spabizToken);
			if (this.club.pages) {
				this.bookingConfirmationPage = this.club.pages.lifespaBookingConfirmation;
			}
			const slot: LifeSpa.ISlot = storageService.get<LifeSpa.ISlot>(StorageConstant.lifespaSlot) as LifeSpa.ISlot;
			if (slot) {
				this.slot = slot;
				this.date = moment(this.slot.fulldatetime, 'DD-MMM-YY').format('dddd, MMMM D');
				const timeAdd = moment(this.slot.value, 'h:m a').add(this.slot.duration, 'minutes');
				this.endTime = timeAdd.format('h:mm');
				this.endTimeSession = moment(timeAdd, 'h:mm a').format('a');
				this.startTime = moment(this.slot.value, 'h:mm').format('h:mm');
			}
		});
	},
});
